import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categoryData';

export default function CategoryGrid() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            资源分类导航
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            八大分类覆盖主流视频类型，点击进入查看对应资源列表
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-100 rounded-xl p-5 md:p-6 text-center hover:bg-accent-50 transition-all duration-300 cursor-pointer border border-transparent hover:border-accent-200"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 mx-auto mb-3 flex items-center justify-center bg-accent-100 rounded-xl group-hover:bg-accent-200 transition-colors">
                <i className={`${cat.icon} text-xl md:text-2xl text-accent-600`}></i>
              </div>
              <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-800 mb-1 whitespace-nowrap">
                {cat.name}
              </h3>
              <span className="text-xs text-foreground-400">
                {cat.count}个资源
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}